// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3XcwY","box":"WorkspacesBox_box__2SjcF","node":"WorkspacesBox_node__1-wCI"};